import { SideImage } from '../../components/SideImage';
import { StickyFooter } from '../../components/StickyFooter';
import { BookingTopBar } from '../../composites/BookingTopBar';
import { GolfBookingContent } from '../../composites/GolfBookingContent';
import { SplitLayout } from '../../composites/SplitLayout';
import type { GolfBookingFormProps } from './GolfBookingForm.types';

export function GolfBookingForm({
  imageUrl,
  imageAlt,
  onBack,
  progressStep,
  progressTotal,
  stickyFooter,
  labels,
  ...contentProps
}: GolfBookingFormProps) {
  const {
    title,
    subtitle,
    noteText,
    backLabel,
    progressLabel,
    progressValueText,
    calendar,
    stickyFooter: stickyFooterLabels,
    ...contentLabels
  } = labels;

  return (
    <SplitLayout
      left={<SideImage src={imageUrl} alt={imageAlt} sticky />}
      right={
        <>
          <BookingTopBar
            inset={false}
            onBack={onBack}
            backLabel={backLabel}
            progressStep={progressStep}
            progressTotal={progressTotal}
            progressLabel={progressLabel}
            progressValueText={progressValueText}
          />
          <GolfBookingContent
            {...contentProps}
            title={title}
            subtitle={subtitle}
            noteText={noteText}
            onBack={onBack}
            calendarLabels={calendar}
            labels={contentLabels}
          />
          {stickyFooter && (
            <StickyFooter
              {...stickyFooter}
              totalLabel={stickyFooterLabels?.totalLabel}
              ctaLabel={stickyFooterLabels?.ctaLabel ?? 'Add to basket'}
            />
          )}
        </>
      }
      leftWidth="45%"
      contentGap="0px"
      contentMaxWidth="100%"
      hideLeftOnMobile
    />
  );
}
